import { OrganizationPermission } from '../../api'

type TopUserFlags = { isTopUser?: boolean | null; isTopPowerUser?: boolean | null }

/**
 * A top user belongs to every root organization, as a power user only when isTopPowerUser is set.
 */
export const topUserOrganizations = (
  rootOrganizations: { id: string }[],
  isTopPowerUser: boolean | null | undefined,
): OrganizationPermission[] => rootOrganizations.map(org => ({ organizationId: org.id, isPowerUser: !!isTopPowerUser }))

/**
 * Untouched checkboxes are undefined in the form, and a hidden Power User checkbox keeps its last
 * value, so resolve both flags to booleans where only a top user can be a top power user.
 */
export const normalizeTopUserFlags = ({ isTopUser, isTopPowerUser }: TopUserFlags) => ({
  isTopUser: !!isTopUser,
  isTopPowerUser: !!isTopUser && !!isTopPowerUser,
})
